var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "timeline"
  }, [_c('h2', {
    staticClass: "timeline__title"
  }, [_vm._v("Знаете ли, че?")]), _vm._v(" "), _vm._l((_vm.articles), function(article) {
    return _c('div', {
      staticClass: "timeline__item"
    }, [_c('div', {
      staticClass: "timeline__item-image"
    }, [_c('img', {
      attrs: {
        "src": article.image,
        "alt": "Timeline"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "timeline__item-title",
      domProps: {
        "innerHTML": _vm._s(article.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline__item-description",
      domProps: {
        "innerHTML": _vm._s(article.description)
      }
    })])
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f20d0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/articles.vue
// module id = GqZB
// module chunks = 1